import { render, staticRenderFns } from "./DomainSearchChart.vue?vue&type=template&id=d38a6c0c&scoped=true&"
import script from "./DomainSearchChart.vue?vue&type=script&lang=js&"
export * from "./DomainSearchChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38a6c0c",
  null
  
)

/* custom blocks */
import block0 from "./DomainSearchChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports